import { Box, Typography } from '@mui/material';
import React from 'react';

// Small pill for secondary readings, e.g. "SOH 98 %"
const DetailLabel = ({
  label,
  value,
  unit,
}) => {
  return (
    <Box sx={{
      display: "inline-flex",
      alignItems: "baseline",
      gap: 0.75,
      px: 1.25,
      py: 0.5,
      borderRadius: "999px",
      backgroundColor: "var(--c-surface)",
      border: "1px solid var(--c-border)",
      whiteSpace: "nowrap",
    }}>
      <Typography sx={{ fontSize: 12, color: "var(--c-text-muted)", lineHeight: 1.4 }}>
        {label}
      </Typography>
      <Typography sx={{
        fontSize: 12,
        fontWeight: 600,
        color: "var(--c-text)",
        lineHeight: 1.4,
        fontVariantNumeric: "tabular-nums",
      }}>
        {`${value} ${unit}`}
      </Typography>
    </Box>
  )
}

export default DetailLabel;
